
import { IAcl } from '../IAcl';

export default class UserMonitored implements IAcl {
	public group?: string;

	public isVisitorAcl = false;

	public constructor() {
		this.group = 'User';
	}

	public canRead(): boolean {
		// % protected region % [Override read rule contents here here] on begin
		return true;
		// % protected region % [Override read rule contents here here] end
	}

	public canCreate(): boolean {
		// % protected region % [Override create rule contents here here] on begin
		return true;
		// % protected region % [Override create rule contents here here] end
	}

	public canUpdate(): boolean {
		// % protected region % [Override update rule contents here here] on begin
		return true;
		// % protected region % [Override update rule contents here here] end
	}

	public canDelete(): boolean {
		// % protected region % [Override delete rule contents here here] on begin
		return true;
		// % protected region % [Override delete rule contents here here] end
	}
}
